import { useHistory } from 'react-router-dom';

import AccountingSetupCompletion from './AccountingSetupCompletion';

/**
 * Standalone Completion Page for Accounting Setup
 *
 * This page renders outside of StepWizard2 to provide a full-screen completion experience
 * without the sidebar stepper or bottom footer, matching the Figma design exactly.
 *
 * Note: The backend automatically marks onboarding as completed when all steps are done,
 * so we don't need to make an API call here.
 */
function CompletionPage() {
    const history = useHistory();

    const handleComplete = () => {
        // The backend automatically sets is_completed = True and completed_at when all steps are done
        // Redirect to bookkeeping dashboard
        history.push('/bookkeeping/dashboard');
    };

    return <AccountingSetupCompletion onComplete={handleComplete} />;
}

export default CompletionPage;
